<template>
  <div class="preloader">
    <v-progress-circular
      :size="50"
      color="dark"
      indeterminate
    ></v-progress-circular>
  </div>
</template>

<script>
    export default {
        name: 'preloader'
    }
</script>

<style scoped>
  .preloader {
    background-color: black;
    position: absolute;
    top: 0px;
    left: 0px;
    /*background-size: 100px;*/
    /*background-image: url("../../assets/loader.gif");*/
    /*background-position: center;*/
    /*background-repeat: no-repeat;*/
    width: 100%;
    height: 100%;
    z-index: 9999999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/preloader.vue